// extracted by mini-css-extract-plugin
module.exports = {"image":"FullWidthImage_image__VjGSC","caption":"FullWidthImage_caption__SaJ4c"};